export default function PartnerSupportData(accountName) {
  return { 
    accountName: accountName,
    support: [
      {
        title: "Protect your family",
        backgroundImageUrl: "https://assets.covrtech.com/Consumer/landing-assets/term_3_1/family_hands.png"
      },
      {
        title: "Protect your income",
        backgroundImageUrl: "https://assets.covrtech.com/Consumer/landing-assets/term_3_1/bank.png"
      },
      {
        title: "Protect your assets",
        backgroundImageUrl: "https://assets.covrtech.com/Consumer/landing-assets/term_3_1/house.png"
      },
    ]
  }
};